import React from 'react'
import moment from 'moment'

// material ui
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import { useBrand } from 'components/shared/SettingsProvider'

const FinancialAidInfo = props => {
  const { account, sessions, onApply } = props
  const { marcomUrl } = useBrand()

  if (!sessions || sessions.length === 0) {
    return null
  }

  // Split sessions into open and future based on the server-provided open datetime (includes timezone)
  const now = new Date()
  const openSessions = sessions.filter(s => new Date(s.financialAidOpenAt) <= now)
  const futureSessions = sessions.filter(s => new Date(s.financialAidOpenAt) > now)

  // Determine if financial aid is available to apply
  let financialAidAvailable = false
  let earliestFutureDate = null

  if (openSessions.length > 0) {
    if (account) {
      // Get unique years from open sessions
      const openYears = [...new Set(openSessions.map(s => s.year))]

      // Check if user has approvals for ALL open years
      const hasApprovalForAllYears = openYears.every(year =>
        account.financialAidApprovals?.find(approval => approval.year === year)
      )

      if (hasApprovalForAllYears) {
        return null
      }
    }

    financialAidAvailable = true
  } else if (futureSessions.length > 0) {
    // Sort by date and get the earliest
    const earliestFutureSession = futureSessions.sort(
      (a, b) => a.financialAidOpenAt.localeCompare(b.financialAidOpenAt)
    )[0]
    earliestFutureDate = earliestFutureSession.financialAidOpenAt
  } else {
    return null
  }

  const formatDate = dateString => {
    return moment(dateString).format('MMMM D, YYYY')
  }

  return (
    <Box my={3}>
      <Card>
        <CardContent>
          <Typography paragraph>
            To learn more about Financial Aid,{' '}
            <Link
              href={`${marcomUrl}/financial-aid`}
              target='_blank'
              rel='noopener noreferrer'
            >
              Click here
            </Link>
          </Typography>

          {financialAidAvailable ? (
            <Box>
              <Typography paragraph fontWeight='fontWeightBold'>
                Would you like to apply for financial aid?
              </Typography>
              <Box display='flex' gap={2}>
                <Button
                  onClick={onApply}
                  variant='outlined'
                  sx={{
                    color: theme => theme.palette.text.secondary
                  }}
                >
                  Click here
                </Button>
              </Box>
            </Box>
          ) : (
            <Typography paragraph>
              Please return after 7AM local time on{' '}
              {formatDate(earliestFutureDate)} to apply.
            </Typography>
          )}
        </CardContent>
      </Card>
    </Box>
  )
}

export default FinancialAidInfo
